import { boolean, number, object, string } from '@/core/utils/validation';
import { getEnumValuesAsArray } from '@/core/utils/convert';
import { InvoiceType } from '@/warehouse/modules/crossdockReceipt/models';
// TODO: to delete redundant comments later.
const createOrDeleteStickerItemMessageSchema = object({
    // task: taskSchema.required(),
    // pickingItem: pickingItemSchema.required(),
    // blockedItem: blockedItemSchema.required(),
    invoiceId: number().integer().positive().required(),
    invoiceReceiptedQuantity: number().min(0).required(),
    invoiceBlockedQuantity: number().min(0).required(),
    invoiceQuantity: number().min(0).required(),
    invoiceAmount: number().required(),
    // TODO: add `invoiceNumber`, `invoiceType` and `trackableStatus` to createOrDeleteStickerItemSocketMessage!!!!!!!
    // invoiceNumber: message.invoiceNumber,
    invoiceNumber: string().required(),
    // invoiceType:message.invoiceId, //  InvoiceType.Utd1 | InvoiceType.Utd2 | InvoiceType.Return;
    invoiceType: number().oneOf(getEnumValuesAsArray(InvoiceType)).required(),
    // invoiceDate: date().typeError(t('invalid.date.error.message')).required(),
    // invoiceDate: date()
    // 	.defined()
    // 	.transform((value) => new Date(value))
    // 	.nonNullable()
    // 	.required(),
    invoiceDate: string().required(),
    supplierName: string().required(),
    receiptItemId: number().integer().positive().required(),
    portionId: number().integer().positive().required(),
    itemQuantity: number().min(0).required(),
    itemReceiptedQuantity: number().min(0).required(),
    itemBlockedQuantity: number().min(0).required(),
    stickerId: number().integer().positive().required(),
    isDeletion: boolean().required(),
    // TODO: add `invoiceNumber`, `invoiceType` and `trackableStatus` to createOrDeleteStickerItemSocketMessage!!!!!!!
    // trackableStatus: number().oneOf(getEnumValuesAsArray(TrackableStatus)).required(),
}).noUnknown(true);
export { createOrDeleteStickerItemMessageSchema };
